export const getParamValue = (param: string) => {
    const urlParams = new URLSearchParams(window.location.search);
    for (const [key, value] of urlParams.entries()) {
        if (key.toLowerCase() === param) {
            return value.toLowerCase();
        }
    }
    return undefined;
};

export const getCurrentHost = () => {
    try {
        // Access the current URL using window.location.href
        const currentUrl = window.location.href;
        const parsedUrl = new URL(currentUrl);
        const protocol = window.location.protocol;
        return protocol + '//' + parsedUrl.host; // Returns the host (e.g., 'localhost:3001' or 'dev')
    } catch (error) {
        console.error('Failed to parse the current URL', error);
        return null;
    }
};
